import React from 'react'
import '../styles/index.scss'

import Header from './header'
import Footer from './footer'
import postlayoutStyles from '../styles/components/postLayout.module.scss'

const Layout = (props) => {
    return (
    <div className={postlayoutStyles.wrapperPosts}>   
        <Header />
        <div className={postlayoutStyles.containerPosts}>
            <div className={postlayoutStyles.contentPosts}>
                <div className={postlayoutStyles.postsLook}>
                    {props.children}
                </div>     
            </div>
        </div>
        <Footer />
    </div> 
    )
}

export default Layout